module.exports = __webpack_public_path__ + "static/media/send-message-btn-mobile-gray.b222db4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/send-message-btn-mobile-gray.png
// module id = 1294
// module chunks = 0